import axios from '@/plugins/axios'

export default {
    getAlert() {
        return axios.httpApi.get('alert')
    }
}
